
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import * as a from '../' 

type Props = {
    formik?: any
}

export const AncientCardBody: React.FC<Props> = ({ formik, children }) => {

    const cardBody = () => {
        return (
            <div className='card-body border-top p-9' style={{ "overflow": "auto" }}>
                {children}
            </div>
        )
    }

    return (
    <>
        {formik == undefined ?
            cardBody()
            :
            <form onSubmit={formik.handleSubmit} noValidate className='form'>
                {cardBody()}
            </form>
        }
    </>

    )
}
